import styles from './styles/NewArrivalsCard.module.scss';
import React from 'react';
import { PER_ROW_MORE } from '../../constants/perRowKeys';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_SORT } from '../../constants/searchParamKeys';
import { useParams, useSearchParams } from 'react-router-dom';
import { activeSortConfigs, collectionData } from '../../configs';
import { dispatchGAEvent } from '../../../events/dispatchGAEvent';
import { useHierarchyContext } from '../../hooks/useHierarchyContext';
const image = 'https://cdn.shopify.com/s/files/1/1568/8443/files/new-arrivals-wall-art.png?v=1652251996';
export const NewArrivalsCard = ({ perRow }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const sortType = searchParams.get(SEARCH_PARAM_KEY_SORT);
    if (!activeSortConfigs.some(({ name }) => name.toLowerCase() === 'newest') ||
        sortType === 'newest')
        return null;
    const { objects } = useHierarchyContext();
    const { handle } = useParams();
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    return (React.createElement("li", { style: { order: 11 } },
        React.createElement("button", { className: `btn:cleared d:flex fd:column ai:center h:100 w:100 text:center bdrs:2 ${styles.card} ${perRow === PER_ROW_MORE ? styles.cardSmall : ''}`, onClick: () => {
                searchParams.set(SEARCH_PARAM_KEY_SORT, 'newest');
                searchParams.sort();
                setSearchParams(searchParams);
                dispatchGAEvent('Collection', 'click', 'New Arrivals Banner');
            } },
            React.createElement("span", { className: `ff:abril-fatface text:uppercase ${styles.textBig}` }, "check out"),
            React.createElement("span", { className: `ff:abril-display text:capitalize ${styles.textSecondary}` }, "our new arrivals"),
            React.createElement("span", { className: `d:flex ai:center w:100 ff:abril-display text:capitalize ${styles.textDecorated}` },
                React.createElement("span", { className: styles.textDecoratedSpan }, "in the")),
            React.createElement("span", { className: `ff:abril-display text:capitalize fw:700 ${styles.textName}` },
                objects[handle ?? '']?.name ?? collectionData.title,
                " collection"),
            React.createElement("img", { className: `mt:auto w:auto ${styles.image}`, src: image, width: 112, height: 138, alt: "New Arrivals Wall Art" }))));
};
